import styled from 'styled-components'

export const Container = styled.div`
  overflow: hidden;

  width: 312px;
`

export const Slide = styled.div`
  width: 100%;
  height: 123px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 12px;

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.5)`};

  p {
    margin: 0;
  }

  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  .value {
    font-size: 2rem;
    font-weight: 500;
    line-height: 2.3rem;
  }

  .label {
    font-size: 1.06rem;
    font-weight: 500;
    line-height: 1.25rem;
  }
`
